import React, { Component } from 'react';
import { Tree, } from 'antd';
import Icon from 'components/Icon';
import { 
  getDefaultAreaCls,
  PlaylistContextMenu,
} from 'components/Playlist'

import { ContextMenuTrigger } from "react-contextmenu";

const TreeNode = Tree.TreeNode;

export default class AreaTree extends Component {
  state = {
    treeData: [],
    autoExpandParent: true,
  }

  renderTreeNodes = (data) => {
    return data.map((item) => {
      if (item.children) {
        return (
          <TreeNode dataRef={item} {...item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode {...item} />;
    });
  }

  generateTreeData = (areaArray, parentIdIn, expandedKeys, selectedKeys, checkedKeys,)=> {
    let tree = [];
    areaArray.forEach((area, index) => {
      let { parentId, areaId, areaName, areaType, anchor_type, mediaAreas } = area;
      
      if(parentId === parentIdIn){
        expandedKeys.push(areaId + '');
        checkedKeys.push(areaId + '');
        let node = {
          key: areaId + '',
          icon: <Icon className={getDefaultAreaCls(areaType)} />,
          title: <React.Fragment><Icon className={getDefaultAreaCls(areaType)} /> {areaName}  ({mediaAreas.length}) {anchor_type === 1 ? window.language['playlist.anchor'] : null}</React.Fragment>,
          children: this.generateTreeData(areaArray, areaId, expandedKeys, selectedKeys, checkedKeys,),
        }

        tree.push(node);
      }
    })
    return tree;
  }
  changeState = (areaArray, expandedKeys, selectedKeys, checkedKeys,) => {
    let treeData = this.generateTreeData(areaArray, 0, expandedKeys, selectedKeys, checkedKeys,);
    let { onChangeTreeState } = this.props;
    this.setState({
      treeData
    })
    onChangeTreeState && onChangeTreeState({expandedKeys, selectedKeys, checkedKeys});
  }

  compareProps = (thisprops, nextprops) => {
    return thisprops.upOrDown === nextprops.upOrDown;
    // let flag = true;
    // let thislength = thisprops.areaArray.length;
    // let nextlength = nextprops.areaArray.length;
    // if(thislength !== nextlength){
    //   flag = false;
    //   return flag;
    // }

    // for(let i = 0; i < thislength; i++){
    //   let thisarray = thisprops.areaArray[i];
    //   let nextarray = nextprops.areaArray[i];
      
    //   let { zIndex: thisZIndex, areaName: thisAreaName } = thisarray;
    //   let { zIndex: nextZIndex, areaName: nextAreaName } = nextarray;
    //   if(thisZIndex !== nextZIndex || thisAreaName !== nextAreaName){
    //     flag = false;
    //     break;
    //   }
    // }
    // return flag;
  }
  componentWillReceiveProps(nextprops){
    //同一个区域，并且zIndex相同,同时区域个数没有变化时return(用compareProps代替)
    if(this.props.currentArea === nextprops.currentArea 
      && this.compareProps(this.props, nextprops)) return;
    let { areaArray, currentArea } = nextprops;
    if(!currentArea) return;
    let { expandedKeys, selectedKeys, checkedKeys } = this.props;
    selectedKeys = [currentArea.areaId + ''];
    this.changeState(areaArray, expandedKeys, selectedKeys, checkedKeys,)
  }
  componentDidMount(){
    let { areaArray, currentArea, } = this.props;
    if(!currentArea) return;
    let { expandedKeys, selectedKeys, checkedKeys } = this.props;
    selectedKeys = [currentArea.areaId + ''];
    this.changeState(areaArray, expandedKeys, selectedKeys, checkedKeys,);
  }
  render() {
    let {
      currentArea,
      centerareaheight,
      onUp,
      onDown,
      onTop,
      onBottom,
      onDelete,
      onClear,
      onMax,
      onExpand,
      onAnchor,
      onLock,
      expandedKeys,
      onSelect,
      selectedKeys,
      onCheck,
      checkedKeys,
    } = this.props;

    let {
      treeData
    } = this.state;

    let { areaType, anchor_type, lock } = currentArea;
    let areaTreeComb = <Tree
      // checkable
      showLine
      // showIcon
      autoExpandParent={false}
      checkStrictly={true}
      onExpand={onExpand} 
      expandedKeys={expandedKeys}
      onCheck={onCheck}
      checkedKeys={checkedKeys}
      onSelect={onSelect}
      selectedKeys={selectedKeys}
      onRightClick={({event, node}) => {
        onSelect([node.props.eventKey])
      }}
    >
      {this.renderTreeNodes(treeData)}
    </Tree>
    const playlistContextMenuProps = {
      id: "playlist_tree_contextmenu", 
      areaType, 
      anchor_type, 
      lock,
      onUp, 
      onDown, 
      onTop, 
      onBottom, 
      onMax, 
      onDelete, 
      onAnchor,
      onLock,
    }
    return (
      <div
				style={{
					left: 0,
					top: 0,
          width: 295,
					// height: centerareaheight,
          // overflowY: 'auto',
          // overflowX:'hidden',
          overflow:'hidden',
				}}
			>
      {
        areaType === -1 ? null : (
          <PlaylistContextMenu {...playlistContextMenuProps}/>
        )
      }
      <ContextMenuTrigger id="playlist_tree_contextmenu">
        { areaTreeComb }
      </ContextMenuTrigger>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Playlist/AreaTree.js